<template>
  <div id="est-option-modal" class="modal"  v-show="modalShown">
    <div class="modal-main">
      <div class="title-area">
        <h2>見積オプション設定</h2>
      </div>
      <!-- ローディングモーダル -->
      <dd-loading-modal ref="loadingModalRef" />
      <div class="data-area">
        <datalist id="discount-items">
          <option v-for="(item, index) in discountItemCodeList" :key= index :value="item.codeTextShort" ></option>
        </datalist>
        <datalist id="additional-cost-items">
          <option v-for="(item, index) in additionalCostItemCodeList" :key= index :value="item.codeTextShort" ></option>
        </datalist>
        <ul>
          <li>
            <span class="label">見積書作成日</span>
            <input type="date" v-model="estimateDate" placeholder="見積書作成日" class="form_contents">
            <div class="validate_error_messages">{{ validateErrorMessages.estimateDate }}</div>
          </li>
          <hr>
          <!-- ul要素の子にspan要素は配置できないため、個々のli要素をv-ifで制御する -->
          <li v-if="isDiscountItem1Enabled">
            <span class="li-label">値引き項目１</span>
          </li>
          <li v-if="isDiscountItem1Enabled">
            <span class="sub-label">項目名</span>
            <input type="text" list="discount-items" v-model="discountItemName1" placeholder="値引き項目名１" class="form_contents">
            <span class="sub-label">金額</span>
            <input type="number" v-model="discountItemPrice1" placeholder="値引き額１" class="form_contents">
            <div class="validate_error_messages">{{ validateErrorMessages.discountItemName1 }}</div>
            <div class="validate_error_messages">{{ validateErrorMessages.discountItemPrice1 }}</div>
          </li>
          <li v-if="isDiscountItem2Enabled">
            <span class="li-label">値引き項目２</span>
          </li>
          <li v-if="isDiscountItem2Enabled">
            <span class="sub-label">項目名</span>
            <input type="text" list="discount-items" v-model="discountItemName2" placeholder="値引き項目名２" class="form_contents">
            <span class="sub-label">金額</span>
            <input type="number" v-model="discountItemPrice2" placeholder="値引き額２" class="form_contents">
            <div class="validate_error_messages">{{ validateErrorMessages.discountItemName2 }}</div>
            <div class="validate_error_messages">{{ validateErrorMessages.discountItemPrice2 }}</div>
          </li>
          <li v-if="isDiscountItem3Enabled">
            <span class="li-label">値引き項目３</span>
          </li>
          <li v-if="isDiscountItem3Enabled">
            <span class="sub-label">項目名</span>
            <input type="text" list="discount-items" v-model="discountItemName3" placeholder="値引き項目名３" class="form_contents">
            <span class="sub-label">金額</span>
            <input type="number" v-model="discountItemPrice3" placeholder="値引き額３" class="form_contents">
            <div class="validate_error_messages">{{ validateErrorMessages.discountItemName3 }}</div>
            <div class="validate_error_messages">{{ validateErrorMessages.discountItemPrice3 }}</div>
          </li>
          <hr>
          <li v-if="isAdditionalCostItem1Enabled">
            <span class="li-label">追加費用項目１</span>
          </li>
          <li v-if="isAdditionalCostItem1Enabled">
            <span class="sub-label">項目名</span>
            <input type="text" list="additional-cost-items" v-model="additionalCostItemName1" placeholder="追加費用項目名１" class="form_contents">
            <span class="sub-label">金額</span>
            <input type="number" v-model="additionalCostItemPrice1" placeholder="追加費用額１" class="form_contents">
            <div class="validate_error_messages">{{ validateErrorMessages.additionalCostItemName1 }}</div>
            <div class="validate_error_messages">{{ validateErrorMessages.additionalCostItemPrice1 }}</div>
          </li>
          <li v-if="isAdditionalCostItem2Enabled">
            <span class="li-label">追加費用項目２</span>
          </li>
          <li v-if="isAdditionalCostItem2Enabled">
            <span class="sub-label">項目名</span>
            <input type="text" list="additional-cost-items" v-model="additionalCostItemName2" placeholder="追加費用項目名２" class="form_contents">
            <span class="sub-label">金額</span>
            <input type="number" v-model="additionalCostItemPrice2" placeholder="追加費用額２" class="form_contents">
            <div class="validate_error_messages">{{ validateErrorMessages.additionalCostItemName2 }}</div>
            <div class="validate_error_messages">{{ validateErrorMessages.additionalCostItemPrice2 }}</div>
          </li>
          <li v-if="isAdditionalCostItem3Enabled">
            <span class="li-label">追加費用項目３</span>
          </li>
          <li v-if="isAdditionalCostItem3Enabled">
            <span class="sub-label">項目名</span>
            <input type="text" list="additional-cost-items" v-model="additionalCostItemName3" placeholder="追加費用項目名３" class="form_contents">
            <span class="sub-label">金額</span>
            <input type="number" v-model="additionalCostItemPrice3" placeholder="追加費用額３" class="form_contents">
            <div class="validate_error_messages">{{ validateErrorMessages.additionalCostItemName3 }}</div>
            <div class="validate_error_messages">{{ validateErrorMessages.additionalCostItemPrice3 }}</div>
          </li>
          <li v-if="isAdditionalCostItem4Enabled">
            <span class="li-label">追加費用項目４</span>
          </li>
          <li v-if="isAdditionalCostItem4Enabled">
            <span class="sub-label">項目名</span>
            <input type="text" list="additional-cost-items" v-model="additionalCostItemName4" placeholder="追加費用項目名４" class="form_contents">
            <span class="sub-label">金額</span>
            <input type="number" v-model="additionalCostItemPrice4" placeholder="追加費用額４" class="form_contents">
            <div class="validate_error_messages">{{ validateErrorMessages.additionalCostItemName4 }}</div>
            <div class="validate_error_messages">{{ validateErrorMessages.additionalCostItemPrice4 }}</div>
          </li>
          <li v-if="isAdditionalCostItem5Enabled">
            <span class="li-label">追加費用項目５</span>
          </li>
          <li v-if="isAdditionalCostItem5Enabled">
            <span class="sub-label">項目名</span>
            <input type="text" list="additional-cost-items" v-model="additionalCostItemName5" placeholder="追加費用項目名５" class="form_contents">
            <span class="sub-label">金額</span>
            <input type="number" v-model="additionalCostItemPrice5" placeholder="追加費用額５" class="form_contents">
            <div class="validate_error_messages">{{ validateErrorMessages.additionalCostItemName5 }}</div>
            <div class="validate_error_messages">{{ validateErrorMessages.additionalCostItemPrice5 }}</div>
          </li>
          <li v-if="isAdditionalCostItem6Enabled">
            <span class="li-label">追加費用項目６</span>
          </li>
          <li v-if="isAdditionalCostItem6Enabled">
            <span class="sub-label">項目名</span>
            <input type="text" list="additional-cost-items" v-model="additionalCostItemName6" placeholder="追加費用項目名６" class="form_contents">
            <span class="sub-label">金額</span>
            <input type="number" v-model="additionalCostItemPrice6" placeholder="追加費用額６" class="form_contents">
            <div class="validate_error_messages">{{ validateErrorMessages.additionalCostItemName6 }}</div>
            <div class="validate_error_messages">{{ validateErrorMessages.additionalCostItemPrice6 }}</div>
          </li>
          <li v-if="isAdditionalCostItem7Enabled">
            <span class="li-label">追加費用項目７</span>
          </li>
          <li v-if="isAdditionalCostItem7Enabled">
            <span class="sub-label">項目名</span>
            <input type="text" list="additional-cost-items" v-model="additionalCostItemName7" placeholder="追加費用項目名７" class="form_contents">
            <span class="sub-label">金額</span>
            <input type="number" v-model="additionalCostItemPrice7" placeholder="追加費用額７" class="form_contents">
            <div class="validate_error_messages">{{ validateErrorMessages.additionalCostItemName7 }}</div>
            <div class="validate_error_messages">{{ validateErrorMessages.additionalCostItemPrice7 }}</div>
          </li>
          <li v-if="isAdditionalCostItem8Enabled">
            <span class="li-label">追加費用項目８</span>
          </li>
          <li v-if="isAdditionalCostItem8Enabled">
            <span class="sub-label">項目名</span>
            <input type="text" list="additional-cost-items" v-model="additionalCostItemName8" placeholder="追加費用項目名８" class="form_contents">
            <span class="sub-label">金額</span>
            <input type="number" v-model="additionalCostItemPrice8" placeholder="追加費用額８" class="form_contents">
            <div class="validate_error_messages">{{ validateErrorMessages.additionalCostItemName8 }}</div>
            <div class="validate_error_messages">{{ validateErrorMessages.additionalCostItemPrice8 }}</div>
          </li>
        </ul>
      </div>
      <div class="error_message">{{ errorMessage.text }}</div>
      <div class="button-area">
      <button type="button" class="main_btn" v-if="estimateId" @click="updateEstOptionData">設定</button>
      <button type="button" class="main_btn" v-else @click="updateEstOptionData">登録</button>
      <button type="button" class="main_btn" @click="onCancel">キャンセル</button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import * as Api from '../../../utils/Api'
import * as AppUtil from '../../../utils/App'
import {API_URL} from '../../../constants/App'
import LoadingModal from '../../common/LoadingModal'

export default {
  name: 'EstOptionModal',
  components: {
    'dd-loading-modal': LoadingModal
  },
  data () {
    return {
      /** モーダル開閉 */
      modalShown: false,
      /** 値引き項目用コードリスト */
      discountItemCodeList: [],
      /** 追加費用項目用コードリスト */
      additionalCostItemCodeList: [],
      /** 見積オプション */
      propertyId: null,
      estimateId: null,
      estimateDate: null,
      isDiscountItem1Enabled: false,
      discountItemName1: null,
      discountItemPrice1: null,
      isDiscountItem2Enabled: false,
      discountItemName2: null,
      discountItemPrice2: null,
      isDiscountItem3Enabled: false,
      discountItemName3: null,
      discountItemPrice3: null,
      isAdditionalCostItem1Enabled: false,
      additionalCostItemName1: null,
      additionalCostItemPrice1: null,
      isAdditionalCostItem2Enabled: false,
      additionalCostItemName2: null,
      additionalCostItemPrice2: null,
      isAdditionalCostItem3Enabled: false,
      additionalCostItemName3: null,
      additionalCostItemPrice3: null,
      isAdditionalCostItem4Enabled: false,
      additionalCostItemName4: null,
      additionalCostItemPrice4: null,
      isAdditionalCostItem5Enabled: false,
      additionalCostItemName5: null,
      additionalCostItemPrice5: null,
      isAdditionalCostItem6Enabled: false,
      additionalCostItemName6: null,
      additionalCostItemPrice6: null,
      isAdditionalCostItem7Enabled: false,
      additionalCostItemName7: null,
      additionalCostItemPrice7: null,
      isAdditionalCostItem8Enabled: false,
      additionalCostItemName8: null,
      additionalCostItemPrice8: null,
      errorMessage: {
        text: null
      },
      validateErrorMessages: {}
    }
  },
  methods: {
    /** 新規モーダル */
    showModal: function (data) {
      this.clearData()
      this.getEstimateData(data)
      this.modalShown = true
    },
    /** キャンセル */
    onCancel: function () {
      this.clearData()
      this.modalShown = false
    },
    /** 見積オプション情報取得 */
    getEstimateData: function (data) {
      axios.get(API_URL.PROPERTY + '/estimate/' + data.cpropertyId
      ).then(response => {
        this.discountItemCodeList = response.data.data.discountItemCodeList
        this.additionalCostItemCodeList = response.data.data.additionalCostItemCodeList
        this.isDiscountItem1Enabled = response.data.data.isDiscountItem1Enabled
        this.isDiscountItem2Enabled = response.data.data.isDiscountItem2Enabled
        this.isDiscountItem3Enabled = response.data.data.isDiscountItem3Enabled
        this.isAdditionalCostItem1Enabled = response.data.data.isAdditionalCostItem1Enabled
        this.isAdditionalCostItem2Enabled = response.data.data.isAdditionalCostItem2Enabled
        this.isAdditionalCostItem3Enabled = response.data.data.isAdditionalCostItem3Enabled
        this.isAdditionalCostItem4Enabled = response.data.data.isAdditionalCostItem4Enabled
        this.isAdditionalCostItem5Enabled = response.data.data.isAdditionalCostItem5Enabled
        this.isAdditionalCostItem6Enabled = response.data.data.isAdditionalCostItem6Enabled
        this.isAdditionalCostItem7Enabled = response.data.data.isAdditionalCostItem7Enabled
        this.isAdditionalCostItem8Enabled = response.data.data.isAdditionalCostItem8Enabled

        const option = response.data.data.estimateOption
        this.propertyId = option.propertyId
        this.estimateId = option.estimateId
        this.estimateDate = this.getFormatDate(option.estimateDate)
        this.discountItemName1 = option.discountItemName1
        this.discountItemPrice1 = option.discountItemPrice1
        this.discountItemName2 = option.discountItemName2
        this.discountItemPrice2 = option.discountItemPrice2
        this.discountItemName3 = option.discountItemName3
        this.discountItemPrice3 = option.discountItemPrice3
        this.additionalCostItemName1 = option.additionalCostItemName1
        this.additionalCostItemPrice1 = option.additionalCostItemPrice1
        this.additionalCostItemName2 = option.additionalCostItemName2
        this.additionalCostItemPrice2 = option.additionalCostItemPrice2
        this.additionalCostItemName3 = option.additionalCostItemName3
        this.additionalCostItemPrice3 = option.additionalCostItemPrice3
        this.additionalCostItemName4 = option.additionalCostItemName4
        this.additionalCostItemPrice4 = option.additionalCostItemPrice4
        this.additionalCostItemName5 = option.additionalCostItemName5
        this.additionalCostItemPrice5 = option.additionalCostItemPrice5
        this.additionalCostItemName6 = option.additionalCostItemName6
        this.additionalCostItemPrice6 = option.additionalCostItemPrice6
        this.additionalCostItemName7 = option.additionalCostItemName7
        this.additionalCostItemPrice7 = option.additionalCostItemPrice7
        this.additionalCostItemName8 = option.additionalCostItemName8
        this.additionalCostItemPrice8 = option.additionalCostItemPrice8
      }).catch(error => {
        Api.handleError(error)
      })
    },
    /** 見積オプション情報更新 */
    updateEstOptionData: function () {
      // バリデーションチェック
      let validList = []
      this.validateErrorMessages = {}
      validList.push(this.validNameAndCost(this.discountItemName1, this.discountItemPrice1, 'discountItemName1', '値引き金額１'))
      validList.push(this.validNameAndCost(this.discountItemName2, this.discountItemPrice2, 'discountItemName2', '値引き金額２'))
      validList.push(this.validNameAndCost(this.discountItemName3, this.discountItemPrice3, 'discountItemName3', '値引き金額３'))
      validList.push(this.validNameAndCost(this.additionalCostItemName1, this.additionalCostItemPrice1, 'additionalCostItemName1', '追加費用額１'))
      validList.push(this.validNameAndCost(this.additionalCostItemName2, this.additionalCostItemPrice2, 'additionalCostItemName2', '追加費用額２'))
      validList.push(this.validNameAndCost(this.additionalCostItemName3, this.additionalCostItemPrice3, 'additionalCostItemName3', '追加費用額３'))
      validList.push(this.validNameAndCost(this.additionalCostItemName4, this.additionalCostItemPrice4, 'additionalCostItemName4', '追加費用額４'))
      validList.push(this.validNameAndCost(this.additionalCostItemName5, this.additionalCostItemPrice5, 'additionalCostItemName5', '追加費用額５'))
      validList.push(this.validNameAndCost(this.additionalCostItemName6, this.additionalCostItemPrice6, 'additionalCostItemName6', '追加費用額６'))
      validList.push(this.validNameAndCost(this.additionalCostItemName7, this.additionalCostItemPrice7, 'additionalCostItemName7', '追加費用額７'))
      validList.push(this.validNameAndCost(this.additionalCostItemName8, this.additionalCostItemPrice8, 'additionalCostItemName8', '追加費用額８'))
      let isValid = true
      validList.forEach(e => {
        if (!e) {
          isValid = e
        }
      })
      if (!isValid) { return }
      this.$refs.loadingModalRef.showModal(true)
      let payload = {
        propertyId: this.propertyId,
        estimateId: this.estimateId,
        estimateDate: this.estimateDate,
        discountItemName1: this.discountItemName1,
        discountItemPrice1: this.discountItemPrice1,
        discountItemName2: this.discountItemName2,
        discountItemPrice2: this.discountItemPrice2,
        discountItemName3: this.discountItemName3,
        discountItemPrice3: this.discountItemPrice3,
        additionalCostItemName1: this.additionalCostItemName1,
        additionalCostItemPrice1: this.additionalCostItemPrice1,
        additionalCostItemName2: this.additionalCostItemName2,
        additionalCostItemPrice2: this.additionalCostItemPrice2,
        additionalCostItemName3: this.additionalCostItemName3,
        additionalCostItemPrice3: this.additionalCostItemPrice3,
        additionalCostItemName4: this.additionalCostItemName4,
        additionalCostItemPrice4: this.additionalCostItemPrice4,
        additionalCostItemName5: this.additionalCostItemName5,
        additionalCostItemPrice5: this.additionalCostItemPrice5,
        additionalCostItemName6: this.additionalCostItemName6,
        additionalCostItemPrice6: this.additionalCostItemPrice6,
        additionalCostItemName7: this.additionalCostItemName7,
        additionalCostItemPrice7: this.additionalCostItemPrice7,
        additionalCostItemName8: this.additionalCostItemName8,
        additionalCostItemPrice8: this.additionalCostItemPrice8
      }

      if (!this.estimateId) {
        axios.post(API_URL.PROPERTY + '/estimate/add', payload
        ).then(response => {
          this.$refs.loadingModalRef.showModal(false)
          let modalData = {
            messages: ['登録しました'],
            onOk: () => {
              this.modalShown = false
              this.$emit('getPropertyList')
            }
          }
          this.validateErrorMessages = {}
          AppUtil.showModal(modalData)
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
      } else {
        axios.post(API_URL.PROPERTY + '/estimate/update', payload
        ).then(response => {
          this.$refs.loadingModalRef.showModal(false)
          let modalData = {
            messages: ['変更しました'],
            onOk: () => {
              this.modalShown = false
              this.$emit('getPropertyList')
            }
          }
          this.validateErrorMessages = {}
          AppUtil.showModal(modalData)
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
      }
    },
    /** 入力チェック */
    validNameAndCost: function (itemName, itemPrice, key, errorMessage) {
      if ((!itemName && itemPrice) || (itemName && !itemPrice)) {
        this.$set(this.validateErrorMessages, key, '項目名と金額は両方入力してください。')
        return false
      }
      if (itemPrice && String(itemPrice).length > 8) {
        this.$set(this.validateErrorMessages, key, errorMessage + 'は8桁以下の整数で入力してください。')
        return false
      }
      var pattern = /^[0-9]+$/
      if (itemPrice && !pattern.test(itemPrice)) {
        this.$set(this.validateErrorMessages, key, errorMessage + 'は整数で入力してください。')
        return false
      }
      this.$set(this.validateErrorMessages, key, '')
      return true
    },
    clearData: function () {
      this.propertyId = null
      this.estimateDate = null
      this.isDiscountItem1Enabled = false
      this.discountItemName1 = null
      this.discountItemPrice1 = null
      this.isDiscountItem2Enabled = false
      this.discountItemName2 = null
      this.discountItemPrice2 = null
      this.isDiscountItem3Enabled = false
      this.discountItemName3 = null
      this.discountItemPrice3 = null
      this.isAdditionalCostItem1Enabled = false
      this.additionalCostItemName1 = null
      this.additionalCostItemPrice1 = null
      this.isAdditionalCostItem2Enabled = false
      this.additionalCostItemName2 = null
      this.additionalCostItemPrice2 = null
      this.isAdditionalCostItem3Enabled = false
      this.additionalCostItemName3 = null
      this.additionalCostItemPrice3 = null
      this.isAdditionalCostItem4Enabled = false
      this.additionalCostItemName4 = null
      this.additionalCostItemPrice4 = null
      this.isAdditionalCostItem5Enabled = false
      this.additionalCostItemName5 = null
      this.additionalCostItemPrice5 = null
      this.isAdditionalCostItem6Enabled = false
      this.additionalCostItemName6 = null
      this.additionalCostItemPrice6 = null
      this.isAdditionalCostItem7Enabled = false
      this.additionalCostItemName7 = null
      this.additionalCostItemPrice7 = null
      this.isAdditionalCostItem8Enabled = false
      this.additionalCostItemName8 = null
      this.additionalCostItemPrice8 = null
      this.validateErrorMessages = {}
      this.errorMessage.text = null
      this.discountItemCodeList = []
      this.additionalCostItemCodeList = []
    },
    getFormatDate: function (date) {
      if (date) {
        return moment(date).format('YYYY-MM-DD')
      } else {
        return ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
li{
  margin-bottom: 10px;
  .li-label{
    min-width: 400px;
    display: inline-block;
    text-align: left;
    font-weight: bold;
    margin-left: 0px;
  }
  .label{
    min-width: 190px;
    display: inline-block;
    text-align: left;
    font-weight: bold;
  }
  .sub-label{
    min-width: 50px;
    display: inline-block;
    text-align: left;
    margin-left: 120px;
  }
}
.data-area {
  padding: 20px;
  max-height: 620px;
  overflow: auto;
}
.modal-main{
  max-height: 100%;
}
.count_limit{
  font-size: 8px;
}
.form_contents{
    min-width: 220px;
}
.validate_error_messages {
  color: #dc3545;
  text-align: left;
  margin-left: 100px;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/list/modal/EstOptionModal.vue